/**
 * SOLID Review
 * S — Strong. One job: a stable, per-device anonymous identifier for consent decisions, read from
 *     or written to localStorage.
 * O — Good. The id-generation strategy (crypto.randomUUID with a fallback) is the only variation
 *     point.
 * I — N/A — a module of two functions, not an interface.
 * L — N/A — no inheritance hierarchy.
 * D — Strong. No imports; talks to window.localStorage and crypto directly.
 */
// Moved out of infrastructure/consent/ConsentApiAdapter on 2026-08-17, same reasoning as
// shared/tabPersistentStorage: a zero-import wrapper over a browser primitive, with no swappable
// production variant, is shared plumbing rather than a providing adapter. Filing it under
// infrastructure/ made the framework consent provider's use of it a layering violation.
const CONSENT_ID_KEY = 'meyer_consent_id';

/**
 * Stable anonymous identifier for the device's consent decisions.  Lets the
 * backend link pre-login consent to the player once they authenticate.
 */
export function getOrCreateConsentId(): string {
  try {
    const existing = window.localStorage.getItem(CONSENT_ID_KEY);
    if (existing) return existing;
    const id =
      typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID()
        : `cid-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    window.localStorage.setItem(CONSENT_ID_KEY, id);
    return id;
  } catch {
    // localStorage unavailable (private mode / SSR) — fall back to an ephemeral id.
    return `cid-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}
